module.exports = __webpack_public_path__ + "img/arrow-right.9fd58330.svg";